// Cálculos del reporte de rastreo, aparte del componente para poder probarlos.

// Del 4 en adelante son incidencias: momentos en que el seguimiento no pudo capturar.
// Verlas importa porque un mapa vacio no distingue "apago la ubicacion" de "no trabajo".
export const PRIMERA_INCIDENCIA = 4;

export const esIncidencia = (kind) => Number(kind) >= PRIMERA_INCIDENCIA;

export const tieneUbicacion = (p) =>
	p.latitude !== null && p.latitude !== undefined && p.longitude !== null && p.longitude !== undefined;

/**
 * Una línea por gestor con sus puntos de recorrido, en el orden en que llegan (por fecha).
 * Antes era una sola línea con todos los puntos: con "Todos" unía la última posición de
 * gestores distintos como si fuera un trayecto.
 * @returns {{nombre: string, puntos: number[][]}[]} Solo los gestores con dos puntos o más.
 */
export const trazosPorGestor = (puntos = []) => {
	const porGestor = new Map();
	puntos
		.filter((p) => !esIncidencia(p.kind) && tieneUbicacion(p))
		.forEach((p) => {
			if (!porGestor.has(p.fullName)) porGestor.set(p.fullName, []);
			porGestor.get(p.fullName).push([p.latitude, p.longitude]);
		});
	return [...porGestor.entries()]
		.filter(([, linea]) => linea.length > 1)
		.map(([nombre, linea]) => ({ nombre, puntos: linea }));
};

/** Esquinas del rectángulo que contiene todos los puntos ubicables, o null si no hay ninguno. */
export const limitesDelMapa = (puntos = []) => {
	const ubicados = puntos.filter(tieneUbicacion);
	if (ubicados.length === 0) return null;
	const lats = ubicados.map((p) => p.latitude);
	const lngs = ubicados.map((p) => p.longitude);
	return [
		[Math.min(...lats), Math.min(...lngs)],
		[Math.max(...lats), Math.max(...lngs)]
	];
};

/** Cuántos puntos, la primera y la última señal y cuántas incidencias hubo. */
export const resumenRecorrido = (puntos = []) => {
	const ordenados = [...puntos].sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
	return {
		puntos: puntos.filter((p) => !esIncidencia(p.kind)).length,
		incidencias: puntos.filter((p) => esIncidencia(p.kind)).length,
		primera: ordenados.length > 0 ? ordenados[0].fecha : null,
		ultima: ordenados.length > 0 ? ordenados[ordenados.length - 1].fecha : null
	};
};
